import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push as Push } from 'redux-first-history';
import { useParams } from 'react-router-dom';
import { safelyEncodeBase64Url } from '@dev/ee-tools';

import { Close as CloseIcon } from '@material-ui/icons';
import { Dialog, Portal } from '@material-ui/core';
import styled from 'styled-components';

import { SetToastPortalWrapper } from '@/store/toast/actions';
import { getContactsStore } from '@/store/contacts/actions';
import { getUploadStore, SetAnalyticsOpen } from '@/store/upload/actions';
import { ContactsPaths } from '@/services/dictionaries/Paths';
import { AnalyticsTable } from './AnalyticsTable';
import { AnalyticsGraphSection } from './AnalyticsGraphSection';
import { getPathParams } from '../../../helperFunctions';

const AnalyticsContainer = styled.div`
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: row;
`;
const AnalyticsTableContainer = styled.div`
    width: 32%;
    min-height: 100%;
    box-shadow: 2px 10px 80px #67679d1a;
    display: flex;
    flex-direction: column;
    padding: 80px;
    justify-content: space-evenly;
`;

const CloseIconContainer = styled.div`
    display: block;
    position: absolute;
    top: 1rem;
    right: 1rem;
    padding: 1rem;
    border-radius: 100%;
    z-index: 1;
    cursor: pointer;
`;

export const Analytics = (): JSX.Element => {
    const { validationStatus } = useSelector(getContactsStore);
    const dispatch = useDispatch();
    const { segmentname, listname } = useParams<{ segmentname: string; listname: string }>();
    const { isAnalyticsOpen } = useSelector(getUploadStore);

    const handleClick = (): void => {
        dispatch(SetToastPortalWrapper(false));
        dispatch(SetAnalyticsOpen(false));
        const [path, pathParam, pathName] = getPathParams(segmentname, listname);
        dispatch(
            Push(
                listname || segmentname
                    ? path.replace(pathParam, safelyEncodeBase64Url(pathName))
                    : ContactsPaths.ContactsOverview
            )
        );
    };

    return (
        <Portal>
            <Dialog fullScreen={true} open={isAnalyticsOpen} onClose={handleClick}>
                <AnalyticsContainer>
                    <CloseIconContainer onClick={handleClick}>
                        <CloseIcon fontSize="large" onClick={handleClick} />
                    </CloseIconContainer>
                    <AnalyticsTableContainer>{validationStatus && <AnalyticsTable />}</AnalyticsTableContainer>
                    <AnalyticsGraphSection />
                </AnalyticsContainer>
            </Dialog>
        </Portal>
    );
};